import classNames from "classnames";
import { Icon } from "../icon/icon";

export const EventImage = ({
  image,
  className = "",
  dimension = 200,
}: {
  image?: File | string;
  className?: string;
  dimension?: number;
}) => {
  return (
    <div
      className={classNames(
        `relative w-full overflow-hidden rounded-[14px] bg-grey-50 pt-[100%] md:pt-0`,
        {
          "md:h-[158px] md:max-h-[158px] md:min-w-[158px] md:max-w-[158px]":
            dimension === 158,
          "md:h-[200px] md:max-h-[200px] md:min-w-[200px] md:max-w-[200px]":
            dimension === 200,
          "md:h-[300px] md:max-h-[300px] md:min-w-[300px] md:max-w-[300px]":
            dimension === 300,
          "md:h-[400px] md:max-h-[400px] md:min-w-[400px] md:max-w-[400px]":
            dimension === 400,
          "md:h-[472px] md:max-h-[472px] md:min-w-[472px] md:max-w-[472px]":
            dimension === 472,
        },
        className,
      )}
    >
      {image ? (
        <img
          className="absolute inset-0 h-full w-full object-cover"
          src={typeof image === "string" ? image : URL.createObjectURL(image)}
          alt="event poster"
        />
      ) : (
        <div className="absolute inset-0 flex h-full w-full flex-col items-center justify-center gap-2 text-grey-500">
          <Icon svg="image" width={24} height={24} />

          <p>Image Preview</p>
        </div>
      )}
    </div>
  );
};
